import { render } from "./SuccessModal.vue?vue&type=template&id=2bf08dab"
import script from "./SuccessModal.vue?vue&type=script&lang=js"
export * from "./SuccessModal.vue?vue&type=script&lang=js"
script.render = render

export default script